import { render, staticRenderFns } from "./menu-loader.vue?vue&type=template&id=5159786c"
import script from "./menu-loader.vue?vue&type=script&lang=ts"
export * from "./menu-loader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports